// Auto-generated from models.xlsx — DO NOT EDIT MANUALLY
// Run generate_models_data.py to regenerate

export interface ModelEntry {
  brand: string;
  model: string;
  slug: string;
  year: number | null;
}

export const BRAND_LABELS: Record<string, string> = {
  Samsung: "סמסונג (Samsung)",
  Apple: "אפל (iPhone)",
  Xiaomi: "שיאומי (Xiaomi)",
  OnePlus: "וואן פלוס (OnePlus)",
  Google: "גוגל Pixel",
};

export const BRAND_EMOJI: Record<string, string> = {
  Samsung: "📱",
  Apple: "🍎",
  Xiaomi: "⚡",
  OnePlus: "🔴",
  Google: "🔵",
};

export const BRAND_ORDER = ["Apple", "Samsung", "Xiaomi", "OnePlus", "Google"];

export const ALL_MODELS: ModelEntry[] = [
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A02",
    "slug": "samsung-galaxy-a02",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A02s",
    "slug": "samsung-galaxy-a02s",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A03",
    "slug": "samsung-galaxy-a03",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A03 Core",
    "slug": "samsung-galaxy-a03-core",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A03s",
    "slug": "samsung-galaxy-a03s",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A04",
    "slug": "samsung-galaxy-a04",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A04e",
    "slug": "samsung-galaxy-a04e",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A04s",
    "slug": "samsung-galaxy-a04s",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A05",
    "slug": "samsung-galaxy-a05",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A05s",
    "slug": "samsung-galaxy-a05s",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A06",
    "slug": "samsung-galaxy-a06",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A07",
    "slug": "samsung-galaxy-a07",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A8 (2018)",
    "slug": "samsung-galaxy-a8-2018",
    "year": 2018
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A8 Plus (2018)",
    "slug": "samsung-galaxy-a8-plus-2018",
    "year": 2018
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A9 (2018)",
    "slug": "samsung-galaxy-a9-2018",
    "year": 2018
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A10",
    "slug": "samsung-galaxy-a10",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A10s",
    "slug": "samsung-galaxy-a10s",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A11",
    "slug": "samsung-galaxy-a11",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A12",
    "slug": "samsung-galaxy-a12",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A13",
    "slug": "samsung-galaxy-a13",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A13 (5G)",
    "slug": "samsung-galaxy-a13-5g",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A14",
    "slug": "samsung-galaxy-a14",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A14 (5G)",
    "slug": "samsung-galaxy-a14-5g",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A15",
    "slug": "samsung-galaxy-a15",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A16",
    "slug": "samsung-galaxy-a16",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A16 (5G)",
    "slug": "samsung-galaxy-a16-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A23",
    "slug": "samsung-galaxy-a23",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A24",
    "slug": "samsung-galaxy-a24",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A25 (5G)",
    "slug": "samsung-galaxy-a25-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A26 (5G)",
    "slug": "samsung-galaxy-a26-5g",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A30",
    "slug": "samsung-galaxy-a30",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A30s",
    "slug": "samsung-galaxy-a30s",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A32",
    "slug": "samsung-galaxy-a32",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A32 (5G)",
    "slug": "samsung-galaxy-a32-5g",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A33 (5G)",
    "slug": "samsung-galaxy-a33-5g",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A34 (5G)",
    "slug": "samsung-galaxy-a34-5g",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A35 (5G)",
    "slug": "samsung-galaxy-a35-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A36 (5G)",
    "slug": "samsung-galaxy-a36-5g",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A50",
    "slug": "samsung-galaxy-a50",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A51",
    "slug": "samsung-galaxy-a51",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A52",
    "slug": "samsung-galaxy-a52",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A52s",
    "slug": "samsung-galaxy-a52s",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A53 (5G)",
    "slug": "samsung-galaxy-a53-5g",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A54 (5G)",
    "slug": "samsung-galaxy-a54-5g",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A55 (5G)",
    "slug": "samsung-galaxy-a55-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A56 (5G)",
    "slug": "samsung-galaxy-a56-5g",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A70",
    "slug": "samsung-galaxy-a70",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A71",
    "slug": "samsung-galaxy-a71",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A72",
    "slug": "samsung-galaxy-a72",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A73 (5G)",
    "slug": "samsung-galaxy-a73-5g",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M12",
    "slug": "samsung-galaxy-m12",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M15 (5G)",
    "slug": "samsung-galaxy-m15-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M23 (5G)",
    "slug": "samsung-galaxy-m23-5g",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M32",
    "slug": "samsung-galaxy-m32",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M53 (5G)",
    "slug": "samsung-galaxy-m53-5g",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M54 (5G)",
    "slug": "samsung-galaxy-m54-5g",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy M55 (5G)",
    "slug": "samsung-galaxy-m55-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Note 9",
    "slug": "samsung-galaxy-note-9",
    "year": 2018
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Note 10",
    "slug": "samsung-galaxy-note-10",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Note 10 Lite",
    "slug": "samsung-galaxy-note-10-lite",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Note 10 Plus",
    "slug": "samsung-galaxy-note-10-plus",
    "year": 2019
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Note 20 Ultra",
    "slug": "samsung-galaxy-note-20-ultra",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S20 FE",
    "slug": "samsung-galaxy-s20-fe",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S20",
    "slug": "samsung-galaxy-s20",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S20 Ultra",
    "slug": "samsung-galaxy-s20-ultra",
    "year": 2020
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S21",
    "slug": "samsung-galaxy-s21",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S21 FE",
    "slug": "samsung-galaxy-s21-fe",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S21 Plus",
    "slug": "samsung-galaxy-s21-plus",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S21 Ultra",
    "slug": "samsung-galaxy-s21-ultra",
    "year": 2021
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S22",
    "slug": "samsung-galaxy-s22",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S22 Plus",
    "slug": "samsung-galaxy-s22-plus",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S22 Ultra",
    "slug": "samsung-galaxy-s22-ultra",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S23 FE",
    "slug": "samsung-galaxy-s23-fe",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S23",
    "slug": "samsung-galaxy-s23",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S23 Plus",
    "slug": "samsung-galaxy-s23-plus",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S23 Ultra",
    "slug": "samsung-galaxy-s23-ultra",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S24 FE",
    "slug": "samsung-galaxy-s24-fe",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S24",
    "slug": "samsung-galaxy-s24",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S24 Plus",
    "slug": "samsung-galaxy-s24-plus",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S24 Ultra",
    "slug": "samsung-galaxy-s24-ultra",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S25 FE",
    "slug": "samsung-galaxy-s25-fe",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S25",
    "slug": "samsung-galaxy-s25",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S25 Plus",
    "slug": "samsung-galaxy-s25-plus",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S25 Ultra",
    "slug": "samsung-galaxy-s25-ultra",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S26",
    "slug": "samsung-galaxy-s26",
    "year": 2026
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S26 Plus",
    "slug": "samsung-galaxy-s26-plus",
    "year": 2026
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S26 Ultra",
    "slug": "samsung-galaxy-s26-ultra",
    "year": 2026
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Flip4",
    "slug": "samsung-galaxy-z-flip4",
    "year": 2022
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Flip6",
    "slug": "samsung-galaxy-z-flip6",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Flip7",
    "slug": "samsung-galaxy-z-flip7",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Fold5",
    "slug": "samsung-galaxy-z-fold5",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Fold6",
    "slug": "samsung-galaxy-z-fold6",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Fold7",
    "slug": "samsung-galaxy-z-fold7",
    "year": 2025
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 8",
    "slug": "apple-iphone-8",
    "year": 2017
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 8 Plus",
    "slug": "apple-iphone-8-plus",
    "year": 2017
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone SE (2020)",
    "slug": "apple-iphone-se-2020",
    "year": 2020
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone SE (2022)",
    "slug": "apple-iphone-se-2022",
    "year": 2022
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone X",
    "slug": "apple-iphone-x",
    "year": 2017
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone XR",
    "slug": "apple-iphone-xr",
    "year": 2018
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone XS",
    "slug": "apple-iphone-xs",
    "year": 2018
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone XS Max",
    "slug": "apple-iphone-xs-max",
    "year": 2018
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 11",
    "slug": "apple-iphone-11",
    "year": 2019
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 11 Pro",
    "slug": "apple-iphone-11-pro",
    "year": 2019
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 11 Pro Max",
    "slug": "apple-iphone-11-pro-max",
    "year": 2019
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 12 Mini",
    "slug": "apple-iphone-12-mini",
    "year": 2020
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 12",
    "slug": "apple-iphone-12",
    "year": 2020
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 12 Pro",
    "slug": "apple-iphone-12-pro",
    "year": 2020
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 12 Pro Max",
    "slug": "apple-iphone-12-pro-max",
    "year": 2020
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 13 Mini",
    "slug": "apple-iphone-13-mini",
    "year": 2021
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 13",
    "slug": "apple-iphone-13",
    "year": 2021
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 13 Pro",
    "slug": "apple-iphone-13-pro",
    "year": 2021
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 13 Pro Max",
    "slug": "apple-iphone-13-pro-max",
    "year": 2021
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 14",
    "slug": "apple-iphone-14",
    "year": 2022
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 14 Plus",
    "slug": "apple-iphone-14-plus",
    "year": 2022
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 14 Pro",
    "slug": "apple-iphone-14-pro",
    "year": 2022
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 14 Pro Max",
    "slug": "apple-iphone-14-pro-max",
    "year": 2022
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 15",
    "slug": "apple-iphone-15",
    "year": 2023
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 15 Plus",
    "slug": "apple-iphone-15-plus",
    "year": 2023
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 15 Pro",
    "slug": "apple-iphone-15-pro",
    "year": 2023
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 15 Pro Max",
    "slug": "apple-iphone-15-pro-max",
    "year": 2023
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 16",
    "slug": "apple-iphone-16",
    "year": 2024
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 16e",
    "slug": "apple-iphone-16e",
    "year": 2025
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 16 Plus",
    "slug": "apple-iphone-16-plus",
    "year": 2024
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 16 Pro",
    "slug": "apple-iphone-16-pro",
    "year": 2024
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 16 Pro Max",
    "slug": "apple-iphone-16-pro-max",
    "year": 2024
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 17",
    "slug": "apple-iphone-17",
    "year": 2025
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 17 Pro",
    "slug": "apple-iphone-17-pro",
    "year": 2025
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone Air",
    "slug": "apple-iphone-air",
    "year": 2025
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 18 Pro",
    "slug": "apple-iphone-18-pro",
    "year": 2026
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 18 Pro Max",
    "slug": "apple-iphone-18-pro-max",
    "year": 2026
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone Duo",
    "slug": "apple-iphone-duo",
    "year": 2026
  },
  {
    "brand": "Apple",
    "model": "Apple iPhone 17 Pro Max",
    "slug": "apple-iphone-17-pro-max",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 8",
    "slug": "xiaomi-redmi-8",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 8A",
    "slug": "xiaomi-redmi-8a",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 9",
    "slug": "xiaomi-redmi-9",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 9A",
    "slug": "xiaomi-redmi-9a",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 9C",
    "slug": "xiaomi-redmi-9c",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 9T",
    "slug": "xiaomi-redmi-9t",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 10A",
    "slug": "xiaomi-redmi-10a",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 10C",
    "slug": "xiaomi-redmi-10c",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 12",
    "slug": "xiaomi-redmi-12",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 12C",
    "slug": "xiaomi-redmi-12c",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 13",
    "slug": "xiaomi-redmi-13",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 13C",
    "slug": "xiaomi-redmi-13c",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 14C",
    "slug": "xiaomi-redmi-14c",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 15C (4G)",
    "slug": "xiaomi-redmi-15c-4g",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 15C (5G)",
    "slug": "xiaomi-redmi-15c-5g",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi A1 Plus",
    "slug": "xiaomi-redmi-a1-plus",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi A3",
    "slug": "xiaomi-redmi-a3",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi A5",
    "slug": "xiaomi-redmi-a5",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 7",
    "slug": "xiaomi-redmi-note-7",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 8",
    "slug": "xiaomi-redmi-note-8",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 8 Pro",
    "slug": "xiaomi-redmi-note-8-pro",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 9",
    "slug": "xiaomi-redmi-note-9",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 9s",
    "slug": "xiaomi-redmi-note-9s",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 9 Pro",
    "slug": "xiaomi-redmi-note-9-pro",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 10",
    "slug": "xiaomi-redmi-note-10",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 10s",
    "slug": "xiaomi-redmi-note-10s",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 10 (5G)",
    "slug": "xiaomi-redmi-note-10-5g",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 10 Pro",
    "slug": "xiaomi-redmi-note-10-pro",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 11",
    "slug": "xiaomi-redmi-note-11",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 11s",
    "slug": "xiaomi-redmi-note-11s",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 11 Pro (5G)",
    "slug": "xiaomi-redmi-note-11-pro-5g",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 12 (4G)",
    "slug": "xiaomi-redmi-note-12-4g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 12 (5G)",
    "slug": "xiaomi-redmi-note-12-5g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 12s",
    "slug": "xiaomi-redmi-note-12s",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 12 Pro (4G)",
    "slug": "xiaomi-redmi-note-12-pro-4g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 12 Pro (5G)",
    "slug": "xiaomi-redmi-note-12-pro-5g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 12 Pro+ (5G)",
    "slug": "xiaomi-redmi-note-12-pro-plus-5g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 13 (4G)",
    "slug": "xiaomi-redmi-note-13-4g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 13 Pro (4G)",
    "slug": "xiaomi-redmi-note-13-pro-4g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 13 Pro (5G)",
    "slug": "xiaomi-redmi-note-13-pro-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 13 Pro+ (5G)",
    "slug": "xiaomi-redmi-note-13-pro-plus-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 14 (4G)",
    "slug": "xiaomi-redmi-note-14-4g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 14 (5G)",
    "slug": "xiaomi-redmi-note-14-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 14 Pro (4G)",
    "slug": "xiaomi-redmi-note-14-pro-4g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 14 Pro (5G)",
    "slug": "xiaomi-redmi-note-14-pro-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi Note 14 Pro+ (5G)",
    "slug": "xiaomi-redmi-note-14-pro-plus-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Mi 9T",
    "slug": "xiaomi-mi-9t",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Mi 9T Pro",
    "slug": "xiaomi-mi-9t-pro",
    "year": 2019
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Mi 10 Lite (5G)",
    "slug": "xiaomi-mi-10-lite-5g",
    "year": 2020
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Mi 11 Lite",
    "slug": "xiaomi-mi-11-lite",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi 12 Lite",
    "slug": "xiaomi-12-lite",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi 13T",
    "slug": "xiaomi-13t",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi 13T Pro",
    "slug": "xiaomi-13t-pro",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi 14T",
    "slug": "xiaomi-14t",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi 14T Pro",
    "slug": "xiaomi-14t-pro",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco F1",
    "slug": "xiaomi-poco-f1",
    "year": 2018
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco F6 Pro (5G)",
    "slug": "xiaomi-poco-f6-pro-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco M3 Pro (5G)",
    "slug": "xiaomi-poco-m3-pro-5g",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco M4 Pro (5G)",
    "slug": "xiaomi-poco-m4-pro-5g",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco M5",
    "slug": "xiaomi-poco-m5",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco M5s",
    "slug": "xiaomi-poco-m5s",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco M6 Pro (4G)",
    "slug": "xiaomi-poco-m6-pro-4g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco M7 Pro (5G)",
    "slug": "xiaomi-poco-m7-pro-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X3 GT",
    "slug": "xiaomi-poco-x3-gt",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X3 Pro",
    "slug": "xiaomi-poco-x3-pro",
    "year": 2021
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X4 Pro (5G)",
    "slug": "xiaomi-poco-x4-pro-5g",
    "year": 2022
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X5 (5G)",
    "slug": "xiaomi-poco-x5-5g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X5 Pro (5G)",
    "slug": "xiaomi-poco-x5-pro-5g",
    "year": 2023
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X6 Pro (5G)",
    "slug": "xiaomi-poco-x6-pro-5g",
    "year": 2024
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X7 (5G)",
    "slug": "xiaomi-poco-x7-5g",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X7 Pro (5G)",
    "slug": "xiaomi-poco-x7-pro-5g",
    "year": 2025
  },
  {
    "brand": "Google",
    "model": "Google Pixel 4a",
    "slug": "google-pixel-4a",
    "year": 2020
  },
  {
    "brand": "Google",
    "model": "Google Pixel 5a (5G)",
    "slug": "google-pixel-5a-5g",
    "year": 2021
  },
  {
    "brand": "Google",
    "model": "Google Pixel 6",
    "slug": "google-pixel-6",
    "year": 2021
  },
  {
    "brand": "Google",
    "model": "Google Pixel 6 Pro",
    "slug": "google-pixel-6-pro",
    "year": 2021
  },
  {
    "brand": "Google",
    "model": "Google Pixel 6a",
    "slug": "google-pixel-6a",
    "year": 2022
  },
  {
    "brand": "Google",
    "model": "Google Pixel 7",
    "slug": "google-pixel-7",
    "year": 2022
  },
  {
    "brand": "Google",
    "model": "Google Pixel 7a",
    "slug": "google-pixel-7a",
    "year": 2023
  },
  {
    "brand": "Google",
    "model": "Google Pixel 8",
    "slug": "google-pixel-8",
    "year": 2023
  },
  {
    "brand": "Google",
    "model": "Google Pixel 8 Pro",
    "slug": "google-pixel-8-pro",
    "year": 2023
  },
  {
    "brand": "Google",
    "model": "Google Pixel 8a",
    "slug": "google-pixel-8a",
    "year": 2024
  },
  {
    "brand": "Google",
    "model": "Google Pixel 9",
    "slug": "google-pixel-9",
    "year": 2024
  },
  {
    "brand": "Google",
    "model": "Google Pixel 9 Pro",
    "slug": "google-pixel-9-pro",
    "year": 2024
  },
  {
    "brand": "Google",
    "model": "Google Pixel 9 Pro XL",
    "slug": "google-pixel-9-pro-xl",
    "year": 2024
  },
  {
    "brand": "Google",
    "model": "Google Pixel 9a",
    "slug": "google-pixel-9a",
    "year": 2025
  },
  {
    "brand": "Google",
    "model": "Google Pixel 10",
    "slug": "google-pixel-10",
    "year": 2025
  },
  {
    "brand": "Google",
    "model": "Google Pixel 10 Pro",
    "slug": "google-pixel-10-pro",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 6T",
    "slug": "oneplus-6t",
    "year": 2018
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 7 Pro",
    "slug": "oneplus-7-pro",
    "year": 2019
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 7T",
    "slug": "oneplus-7t",
    "year": 2019
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 8",
    "slug": "oneplus-8",
    "year": 2020
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 8 Pro",
    "slug": "oneplus-8-pro",
    "year": 2020
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 8T",
    "slug": "oneplus-8t",
    "year": 2020
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 9",
    "slug": "oneplus-9",
    "year": 2021
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 9 Pro",
    "slug": "oneplus-9-pro",
    "year": 2021
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 10 Pro (5G)",
    "slug": "oneplus-10-pro-5g",
    "year": 2022
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 10T (5G)",
    "slug": "oneplus-10t-5g",
    "year": 2022
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 12 (5G)",
    "slug": "oneplus-12-5g",
    "year": 2024
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 12R (5G)",
    "slug": "oneplus-12r-5g",
    "year": 2024
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 13 (5G)",
    "slug": "oneplus-13-5g",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 13R (5G)",
    "slug": "oneplus-13r-5g",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 15 (5G)",
    "slug": "oneplus-15-5g",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord",
    "slug": "oneplus-nord",
    "year": 2020
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord 2 (5G)",
    "slug": "oneplus-nord-2-5g",
    "year": 2021
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord 2T (5G)",
    "slug": "oneplus-nord-2t-5g",
    "year": 2022
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE (5G)",
    "slug": "oneplus-nord-ce-5g",
    "year": 2021
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE2 (5G)",
    "slug": "oneplus-nord-ce2-5g",
    "year": 2022
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE2 Lite (5G)",
    "slug": "oneplus-nord-ce2-lite-5g",
    "year": 2022
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE3 Lite (5G)",
    "slug": "oneplus-nord-ce3-lite-5g",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE4 Lite (5G)",
    "slug": "oneplus-nord-ce4-lite-5g",
    "year": 2024
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord N100",
    "slug": "oneplus-nord-n100",
    "year": 2020
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord N10 (5G)",
    "slug": "oneplus-nord-n10-5g",
    "year": 2020
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord N20 (5G)",
    "slug": "oneplus-nord-n20-5g",
    "year": 2022
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord N30 SE (5G)",
    "slug": "oneplus-nord-n30-se-5g",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 6",
    "slug": "oneplus-6",
    "year": 2018
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 9R (5G)",
    "slug": "oneplus-9r-5g",
    "year": 2021
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 11 (5G)",
    "slug": "oneplus-11-5g",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 11R (5G)",
    "slug": "oneplus-11r-5g",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Open",
    "slug": "oneplus-open",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord 3 (5G)",
    "slug": "oneplus-nord-3-5g",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord 4 (5G)",
    "slug": "oneplus-nord-4-5g",
    "year": 2024
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord 5 (5G)",
    "slug": "oneplus-nord-5-5g",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE3 (5G)",
    "slug": "oneplus-nord-ce3-5g",
    "year": 2023
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord CE4 (5G)",
    "slug": "oneplus-nord-ce4-5g",
    "year": 2024
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy S25 Edge",
    "slug": "samsung-galaxy-s25-edge",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy Z Flip5",
    "slug": "samsung-galaxy-z-flip5",
    "year": 2023
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A26",
    "slug": "samsung-galaxy-a26",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A36",
    "slug": "samsung-galaxy-a36",
    "year": 2025
  },
  {
    "brand": "Samsung",
    "model": "Samsung Galaxy A56",
    "slug": "samsung-galaxy-a56",
    "year": 2025
  },
  {
    "brand": "Google",
    "model": "Google Pixel 10 Pro XL",
    "slug": "google-pixel-10-pro-xl",
    "year": 2025
  },
  {
    "brand": "Google",
    "model": "Google Pixel 10 Pro Fold",
    "slug": "google-pixel-10-pro-fold",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 13",
    "slug": "oneplus-13",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 13R",
    "slug": "oneplus-13r",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus 15",
    "slug": "oneplus-15",
    "year": 2025
  },
  {
    "brand": "OnePlus",
    "model": "OnePlus Nord 5",
    "slug": "oneplus-nord-5",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X7",
    "slug": "xiaomi-poco-x7",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Poco X7 Pro",
    "slug": "xiaomi-poco-x7-pro",
    "year": 2025
  },
  {
    "brand": "Xiaomi",
    "model": "Xiaomi Redmi 15C",
    "slug": "xiaomi-redmi-15c",
    "year": 2025
  }
];
